import { strategyToOptions } from '@/common/utils/strategyToOptions'

export const requireBillReview = {
  never: 'Nunca',
  always: 'Sempre',
}

export const requireBillReviewOptions = strategyToOptions(
  requireBillReview,
)
